document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');

  if (header) {
    const headerClasses = [
      'header-fixed',
      'fixed!',
      'top-0',
      'left-0',
      'w-full',
      'shadow-[0_2px_8px_0_rgba(0,0,0,.25)]',
    ];
    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      if (scrollTop === 0) {
        header.classList.remove(...headerClasses);
      } else {
        header.classList.add(...headerClasses);
      }
    });
  }
});
